import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jteos.lovable.app";

interface SeoHeadProps {
  title: string;          // keep under 60 chars
  description: string;    // 50–160 chars
  path: string;           // e.g. "/pricing"
  ogType?: "website" | "article";
  noindex?: boolean;
  jsonLd?: object | object[];
}

/**
 * Per-route head tags. Provides a unique title, description, and
 * self-referencing canonical so search engines can distinguish pages.
 */
export function SeoHead({ title, description, path, ogType = "website", noindex, jsonLd }: SeoHeadProps) {
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
